import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const resolveBackendUrl = () => {
  if (typeof window === "undefined") {
    return ENV_BACKEND_URL;
  }

  if (!ENV_BACKEND_URL) {
    return window.location.origin;
  }

  try {
    const envOrigin = new URL(ENV_BACKEND_URL).origin;
    const currentOrigin = window.location.origin;

    if (envOrigin !== currentOrigin) {
      return currentOrigin;
    }

    return envOrigin;
  } catch {
    return window.location.origin;
  }
};

export const BACKEND_URL = resolveBackendUrl();

export const apiClient = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});
